import { styled } from '@linaria/react';
import { Link } from 'react-router';
import { getFloraConnectionPath } from '../agent-settings/agent-settings.constants';
import { FloraConnectionId } from '../agent-settings/agent-settings.type';

/** Flora settings page for the Google connection, shared by the grant-access surfaces. */
export const INTEGRATIONS_PAGE_PATH = getFloraConnectionPath(FloraConnectionId.Google);

/** Callout box for the reconnect/picker hints shown while granting sheet access. */
export const Hint = styled.div`
  background-color: var(--sky-lightest);
  border: 1px solid var(--sky-lighter);
  border-radius: 8px;
  padding: 12px 16px;
`;

/** Link styled for use inside {@link Hint}, pointing at the integrations page. */
export const IntegrationsLink = styled(Link)`
  color: var(--secondary-base);
  font-weight: 600;
  text-decoration: underline;
`;
